<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card no-body class="flexbasis365 p-4">
            <b-card-body>
              <b-form @submit.prevent="login">
                <h1>Вход</h1>
                <p class="text-muted">Авторизуйтесь в системе</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><b-icon icon="person" small></b-icon></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="text" class="form-control" v-model="username" placeholder="Логин" autocomplete="username email" />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><b-icon icon="key" small></b-icon></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="password" class="form-control" v-model="password" placeholder="Пароль" autocomplete="current-password" />
                </b-input-group>
                <p class="error">{{ errorMessage }}</p>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" class="px-4" type="submit">Войти</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { userService } from '@/_services'

export default {
  name: 'login',

  data () {
    return {
      username: '',
      password: '',
      errorMessage: ''
    }
  },

  methods: {
    login () {
      this.errorMessage = ''
      const { username, password } = this
      userService.login(username, password).then(status => {
        if (status) {
          localStorage.setItem("LoginName", username)
          this.$router.push('/admin')
        } else {
          this.errorMessage = 'Не правильно введен логин или пароль'
        }
      })
    }
  },
}
</script>

<style scoped>
.app {
  display: flex;
  height: 100vh;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
.error {
  text-align: center;
  color: red;
  font-weight: bold;
}
.flexbasis365 {
  flex-basis: 365px;
}
</style>